import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { RemoteConfigurationService } from './remote-configuration.service';
import { initFlowbite } from 'flowbite';
import { AnalyticsService } from './analytics/analytics.service';
import { FunnelTrackingService } from './analytics/funnel-tracking.service';
import { AttributionService } from './analytics/attribution.service';
import { FirebaseAuthService } from './services/firebase-auth.service';
import { SignupStateService } from './services/signup-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isInitializing = true;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private remoteConfig: RemoteConfigurationService,
    private analyticsService: AnalyticsService,
    // Injected for its side effects: subscribes to router events to track
    // funnel step views and abandonment.
    private funnelTracking: FunnelTrackingService,
    private attributionService: AttributionService,
    private firebaseAuthService: FirebaseAuthService,
    private signupStateService: SignupStateService
  ) {}

  async ngOnInit(): Promise<void> {
    initFlowbite();

    // Initialize anonymous authentication and load data
    await this.initializeApp();
  }

  /**
   * Initialize app: authenticate anonymously and load data from Firestore
   */
  private async initializeApp(): Promise<void> {
    try {
      console.log('Initializing app with anonymous authentication...');

      // Step 1: Initialize anonymous user
      const user = await this.firebaseAuthService.initializeAnonymousAuth();

      if (user) {
        console.log('Anonymous user authenticated:', user.uid);

        // Tie analytics to the anonymous session so funnels survive
        // reloads and GA data can be joined with the signupSessions doc
        this.analyticsService.setUserId(user.uid);

        // Step 2: Start the Firestore-backed signup state (subscribes to the
        // session doc and migrates any legacy localStorage data into it)
        await this.signupStateService.initialize();

        // UTM capture ran at bootstrap, before the signup state was ready —
        // mirror it to the session doc now
        this.attributionService.persistToSession();

        console.log('App initialization complete');
      } else {
        console.warn('Failed to authenticate anonymous user, continuing with localStorage only');
      }
    } catch (error) {
      console.error('Error during app initialization:', error);
      // Continue anyway - app will work with localStorage only
    } finally {
      this.isInitializing = false;
    }
  }
  $isMaintenance = this.remoteConfig.$signupMaintenance;
  centered = false;
  disabled = false;
  unbounded = false;
  firstFormGroup: UntypedFormGroup = this._formBuilder.group({firstCtrl: ['']});
  secondFormGroup: UntypedFormGroup = this._formBuilder.group({secondCtrl: ['']});

  radius = 0;
  color = "FF0000"
  title = 'blazebite-customer-signup';
  emailFormControl = new UntypedFormControl('', [Validators.required, Validators.email]);
}
